import { Dispatch, SetStateAction } from 'react';
import { container, input, labelStyle } from './FormField.css';
import { TextInput } from './TextInput';

type FormFieldProps<T extends number | string | undefined> = {
  label: string;
  Component?: React.ElementType;
  value?: number | string;
  style?: React.CSSProperties;
  onChange?: Dispatch<SetStateAction<T>>;
};

export default function FormField<T>({
  label,
  Component = TextInput,
  value,
  style,
  ...props
}: FormFieldProps<T extends number | string ? T : undefined>) {
  return (
    <label className={[container, value && 'active'].filter((x) => x).join(' ')} style={style}>
      <Component value={value} className={input} {...props} />
      <span className={labelStyle}>{label}</span>
    </label>
  );
}
